import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=49d5c2b4&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./Header.vue?vue&type=style&index=0&id=49d5c2b4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d5c2b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49d5c2b4')) {
      api.createRecord('49d5c2b4', component.options)
    } else {
      api.reload('49d5c2b4', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=49d5c2b4&scoped=true", function () {
      api.rerender('49d5c2b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/component/Header.vue"
export default component.exports